import { useMemo } from "react";

import UAParser from "ua-parser-js";

export function useUserAgent() {
  const userAgent = useMemo(() => new UAParser().getResult(), []);

  const isDesktop =
    userAgent?.device.type === undefined ||
    !["wearable", "mobile"].includes(userAgent?.device.type ?? "");

  return {
    ...userAgent,
    isDesktop,
  };
}
